<div class="edit-container">
	<h1 class="edit-title">Actualizare configurator - module</h1>
	<form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
		<div class="row edit-field">
			<div class="col">
				<mat-form-field appearance="fill">
					<mat-label>Modul</mat-label>
					<mat-select formControlName="module_id">
						<mat-option *ngFor="let module of modules$ | async" [value]="module.id">
							{{ module.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="!form.controls['module_id'].valid && form.controls['module_id'].touched">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="row edit-field">
			<div class="col">
				<mat-form-field appearance="fill">
					<mat-label>Grup</mat-label>
					<mat-select formControlName="group_id">
						<mat-option *ngFor="let group of groupModules$ | async" [value]="group.id">
							{{ group.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="
						!form.controls['group_id'].valid && 
						form.controls['group_id'].touched
					">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>
		</div>

        <div class="row edit-field">
			<div class="col">
				<mat-form-field appearance="fill">
					<mat-label>Permisiune</mat-label>
					<mat-select formControlName="permission_id">
						<mat-option *ngFor="let permission of permissionsModules$ | async" [value]="permission.id">
							{{ permission.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="
						!form.controls['permission_id'].valid &&
						form.controls['permission_id'].touched
					">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="row">
			<div class="col d-flex justify-content-between">
				<button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
					{{ helper.dialogConfig.buttonLabels.close }}
				</button>
				<button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
					{{ helper.dialogConfig.buttonLabels.save }}
				</button>
			</div>
		</div>
	</form>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
		</div>
	</div>
</div>